// composables/useArticlePage.ts
export const useArticlePage = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  const { data } = await useAsyncData(
    `article-${route.path}-${locale.value}`,
    async () => {
      try {
        const [postRes, postsRes] = await Promise.all([
          $fetch('/api/v1/contentful/article', {
            query: {
              locale: locale.value,
              path: route.path,
            },
          }),
          $fetch('/api/v1/contentful/articles', {
            query: {
              locale: locale.value,
            },
          }),
        ])

        const article = postRes?.article ?? null
        let articles = postsRes?.articles ?? []

        articles = articles
          .filter(el => el.title !== article?.title)
          .sort(
            (a, b) =>
              new Date(b.date).getTime() - new Date(a.date).getTime(),
          )

        return {
          article,
          articles,
        }
      } catch (e) {
        console.error(e)
        return {
          article: null,
          articles: [],
        }
      }
    },
  )

  const article = computed(() => data.value?.article)
  const articles = computed(() => data.value?.articles ?? [])

  return {
    article,
    articles,
  }
}
